import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Button, Col, Row } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import { useAlert } from "../../context/AlertContext";
import { useLoading } from "../../context/LoadingContext";
import { findItemInArray } from "../../utils/ManageArray";
import { FloatingControlComponent } from "../FormComponent";
import { getServiceRequest } from "../../commons/ServiceRequest";
import {
  formatDate,
  formatDateTime,
  formatSplitKey,
  formatTime,
  plusStringValue
} from "../../commons/FormatValue";
import Table from "../Table";
import PrintButton from "../PrintButton";
import ReportHeadComponent from "../ReportHeadComponent";
import CardDisplayComponent from "../CardDisplayComponent";
import { formatInputDate, hoursDifference } from "../../utils/Time";

const PreviewRepairPrintForm = () => {
  const navigate = useNavigate();
  const canvasRef = useRef(null);
  const { user } = useAuth();
  const { state } = useLocation();
  const Repair = {
    ...state?.data?.RepairJob,
    Printed_By: user?.username,
    Printed_Date_Time: formatDateTime(new Date().toISOString())
  };
  const inputField = {
    headerReport: [
      {
        name: "repair_doc_no",
        label: "เลขที่แจ้งซ่อม",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 12
      },
      {
        name: "repair_date",
        label: "วันที่รับแจ้งซ่อม",
        size: 6,
        format: (row) => formatDate(row),
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "repair_date",
        label: "เวลา",
        size: 6,
        format: (row) => formatTime(row),
        classNames: { col: "mb-3", label: "mb-1" }
      }
    ],
    Repair: [
      {
        name: "ref_cus_ticket_no",
        label: "อ้างอิง Ticket (ลูกค้า)",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "ref_cus_ticket_date",
        label: "อ้างอิงวันที่แจ้ง(ลูกค้า)",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "job_type_items.Job_Type_Name",
        label: "ประเภทงาน",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "job_type_sub_items.Job_Type_Sub_Name",
        label: "ประเภทงานย่อย",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "inform_about_road",
        label: "ช่องทางรับเรื่อง",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "concern_customer_items.Cus_Code",
        label: "รหัสลูกค้า",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "concern_customer_items.Cus_Name",
        label: "ชื่อลูกค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "project_no",
        label: "เลขโครงการ",
        size: "1_5",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "service_call",
        label: "Service Call",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "concern_customer_items.Cus_Address",
        label: "ที่อยู่",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6,
        plusString: [
          "Cus_Road",
          "Cus_District",
          "Cus_SubDistrict",
          "Cus_Province",
          "Cus_ZipCode"
        ]
      },
      {
        name: "concern_customer_items.Cus_ContactTel",
        label: "ผู้ติดต่อ 1",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "concern_customer_items.Cus_ContactName",
        label: "เบอร์ติดต่อ 1",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "sub_cus_items.Cus_Code",
        label: "รหัสสาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "sub_cus_items.Cus_NumBranch",
        label: "เลขที่สาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "sub_cus_items.Cus_Name",
        label: "ชื่อสาขา",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "sub_cus_items.Cus_ContactName",
        label: "ผู้ติดต่อ 2",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "sub_cus_items.Cus_Address",
        label: "เบอร์ติดต่อ 2",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "InformOtherJob.JobType.Job_Type_Name",
        label: "ที่อยู่",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 9,
        plusString: [
          "Cus_Road",
          "Cus_District",
          "Cus_SubDistrict",
          "Cus_Province",
          "Cus_ZipCode"
        ]
      },
      {
        name: "inform_email",
        label: "E-Mail",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "admin_brand_items",
        label: "ธุรการผู้รับผิดชอบแบรนด์",
        plusString: ["Employee_Name", "Employee_Surname"]
      },
      {
        name: "tech_sub_items",
        label: "ชื่อทีม/หัวหน้าช่าง",
        size: 6,
        plusString: ["Employee_Name", "Employee_Surname"]
      },
      { name: "inform_doc_status", label: "สถานะงานใบแจ้งงาน" }
    ],
    Conditions: [
      { name: "condi_work_tex", label: "เงื่อนไขในการทำงาน", size: 4 },
      {
        name: "condi_work_type",
        label: "งานที่มี PM/ไม่มี PM (ในเดือน)",
        size: 4,
        format: (v) => `${v !== "" ? (v === "PM" ? "มี PM" : "ไม่มี PM") : ""}`
      },
      { name: "Seq_Pm_No", label: "เลขที่ใบสั่งงาน", size: 4 } // รอตาราง Seq PM
    ],
    Approver: [
      {
        name: "iss_job_items", // ใช้ฟิลไหนไม่รู้
        label: "ผู้รับแจ้ง",
        size: 4,
        plusString: ["Employee_Name", "Employee_Surname"]
      },
      {
        name: "iss_job_items",
        label: "ผู้จ่ายงาน (FVC)",
        size: 4,
        plusString: ["Employee_Name", "Employee_Surname"]
      },
      {
        name: "approve_items",
        label: "ผู้อนุมัติ",
        size: 4,
        plusString: ["Employee_Name", "Employee_Surname"]
      }
    ],
    Other: [
      { name: "Printed_By", label: "พิมพ์โดย", size: 4 },
      { name: "Printed_Date_Time", label: "วัน/เวลาที่พิมพ์", size: 4 }
    ]
  };
  const columns = [
    { name: "ลำดับ", selector: (row) => row?.rowIndex, width: "82px" },
    { name: "รหัสอุปกรณ์", selector: (row) => row?.repair_items?.Item_Code },
    {
      name: "รายละเอียดอุปกรณ์",
      selector: (row) => row?.repair_items?.Item_Name_TH,
      grow: 1.75
    },
    { name: "อาการที่ได้รับแจ้ง", selector: (row) => row?.inform_des },
    {
      name: "จน.ชม.ช่างทำงาน (DT)",
      selector: (row) => row?.dt_mas_items?.DT_Hrs
    },
    {
      name: "วัน/เวลา/ครบกำหนด",
      selector: (row) => row?.date_completed,
      format: ({ dt_mas_items, date_completed }) => {
        if (dt_mas_items) {
          const { DT_Hrs } = dt_mas_items;
          const d = new Date(date_completed);
          const hourDiff = hoursDifference(d, DT_Hrs)?.toISOString();
          const dt = formatInputDate(hourDiff, "ISO").datetime;
          return DT_Hrs ? formatDateTime(dt, "DD/MM/YYYY HH:MM น.") : "";
        }
      }
    }
  ];

  const showData = (field) => {
    return field.map(
      (
        { name, label, size, classNames, format, plusString, findValue, style },
        idx
      ) => {
        let value = formatSplitKey(name, ".", Repair);
        const result =
          (format && format(value)) ||
          (plusString && plusStringValue(plusString, " ", value)) ||
          value;

        return (
          <Col
            key={idx}
            sm={size ? size : size === null ? null : 3}
            className={classNames?.col}
          >
            {name && (
              <FloatingControlComponent
                readOnly
                type="text"
                name={name}
                label={label}
                className={classNames}
                style={style}
                value={result}
              />
            )}
          </Col>
        );
      }
    );
  };

  return (
    <div className="position-relative">
      <PrintButton
        componentRef={canvasRef}
        button={{ style: { zIndex: 10, top: "25px", right: "25px" } }}
      />

      <div ref={canvasRef}>
        <CardDisplayComponent
          header={{
            title: { className: "text-center", text: "แสดงและพิมพ์ใบแจ้งซ่อม" }
          }}
          body={{
            as: Row,
            className: "mx-4 px-7",
            element: (
              <>
                <Col
                  sm={9}
                  className="ReportHead mb-3 d-flex align-items-center"
                >
                  <ReportHeadComponent formName="Repair notification form" />
                </Col>

                <Col sm={3} as={Row} className="ms-0 px-0">
                  {showData(inputField.headerReport)}
                </Col>

                {showData(inputField.Repair)}
              </>
            )
          }}
        />

        <CardDisplayComponent
          header={{
            className: "mx-4 px-7",
            title: { text: "รายละเอียดงานที่แจ้ง" }
          }}
          body={{
            className: "mx-4 px-7",
            element: <Table data={state?.data?.Item} column={columns} />
          }}
        />

        <CardDisplayComponent
          body={{
            className: "mx-4 px-7",
            element: showData([
              {
                name: "cus_direct_tex",
                label: "คำสั่งเพิ่มเติม (ลูกค้า)",
                size: 12
              }
            ])
          }}
        />

        <CardDisplayComponent
          body={{
            className: "mx-4 px-7",
            element: showData([
              {
                name: "cus_data_tex",
                label: "ข้อมูลที่ได้รับแจ้ง (ลูกค้า)",
                size: 12
              }
            ])
          }}
        />

        <CardDisplayComponent
          body={{
            as: Row,
            className: "mx-4 px-7",
            element: showData(inputField.Conditions)
          }}
        />

        <CardDisplayComponent
          body={{
            as: Row,
            className: "mx-4 px-7",
            element: showData(inputField.Approver)
          }}
        />

        <CardDisplayComponent
          body={{
            as: Row,
            className: "mx-4 px-7 justify-content-center",
            element: showData(inputField.Other)
          }}
        />
      </div>

      <CardDisplayComponent
        footer={{
          className: "text-center",
          element: (
            <Button
              variant="outline-secondary"
              className="px-4 py-2 text-dark rounded-pill"
              onClick={() =>
                navigate("/repair_work/record", { state: { name: "search" } })
              }
            >
              ย้อนกลับ
            </Button>
          )
        }}
      />
    </div>
  );
};

export default PreviewRepairPrintForm;
